import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchCategoriesBannerData, fetchCategoriesData } from "../ProductManagement/Products/FetchData";

export const getHeaderDrilldownData: { [key in ModuleConfig]: ModuleFields[] } = {
  topHeader: [
    // === SIGN IN SECTION ===
    {
      fieldName: "Sign In Icon Image",
      fieldValue: "field_sign_in_icon_image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "field_sign_in_icon_image",
      formType: "file",
      label: "Sign In Icon Image",
      placeholder: "Enter Sign In Icon Image",
      validation: { required: "Sign In Icon Image is required" },
      imageDimension: {
        width: 25,
        height: 25
      }
    },
    {
      fieldName: "Sign In (EN)",
      fieldValue: "field_sign_in_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_sign_in_text_en",
      formType: "input",
      label: "Sign In (EN)",
      placeholder: "Enter Sign In (EN)",
      validation: { required: "Sign In (EN) is required" },
    },
    {
      fieldName: "Sign In (MS)",
      fieldValue: "field_sign_in_text_malay",
      className: "col-span-6",
      type: "text",
      name: "field_sign_in_text_malay",
      formType: "input",
      label: "Sign In (MS)",
      placeholder: "Enter Sign In (MS)",
    },
    {
      fieldName: "Sign In (ZH)",
      fieldValue: "field_sign_in_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "field_sign_in_text_mandarin",
      formType: "input",
      label: "Sign In (ZH)",
      placeholder: "Enter Sign In (ZH)",
    },
    {
      fieldName: "Register (EN)",
      fieldValue: "field_register_en",
      className: "col-span-6",
      type: "text",
      name: "field_register_en",
      formType: "input",
      label: "Register (EN)",
      placeholder: "Enter Register (EN)",
      validation: { required: "Register (EN) is required" },
    },
    {
      fieldName: "Register (MS)",
      fieldValue: "field_register_ms",
      className: "col-span-6",
      type: "text",
      name: "field_register_ms",
      formType: "input",
      label: "Register (MS)",
      placeholder: "Enter Register (MS)",
    },
    {
      fieldName: "Register (ZH)",
      fieldValue: "field_register_zh",
      className: "col-span-6",
      type: "text",
      name: "field_register_zh",
      formType: "input",
      label: "Register (ZH)",
      placeholder: "Enter Register (ZH)",
    },

    // === LOCATION SECTION ===
    {
      fieldName: "Location Icon Image",
      fieldValue: "field_location_icon_image",
      className: "col-span-6",
      type: "image",
      name: "field_location_icon_image",
      formType: "file",
      label: "Location Icon Image",
      placeholder: "Enter Location Icon Image",
      validation: { required: "Location Icon Image is required" },
      usedFileType: "image/*",
      imageDimension: {
        width: 25,
        height: 25
      }
    },
    {
      fieldName: "Location (EN)",
      fieldValue: "field_location_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_location_text_en",
      formType: "input",
      label: "Location (EN)",
      placeholder: "Enter Location (EN)",
      validation: { required: "Location (EN) is required" },
    },
    {
      fieldName: "Location (MS)",
      fieldValue: "field_location_text_malay",
      className: "col-span-6",
      type: "text",
      name: "field_location_text_malay",
      formType: "input",
      label: "Location (MS)",
      placeholder: "Enter Location (MS)",
    },
    {
      fieldName: "Location (ZH)",
      fieldValue: "field_location_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "field_location_text_mandarin",
      formType: "input",
      label: "Location (ZH)",
      placeholder: "Enter Location (ZH)",
    },

    // === WISHLIST SECTION ===
    {
      fieldName: "Wishlist Icon Image",
      fieldValue: "field_wishlist_icon_image",
      className: "col-span-6",
      type: "image",
      name: "field_wishlist_icon_image",
      formType: "file",
      label: "Wishlist Icon Image",
      placeholder: "Enter Wishlist Icon Image",
      validation: { required: "Wishlist Icon Image is required" },
      usedFileType: "image/*",
      imageDimension: {
        width: 25,
        height: 25
      }
    },
    {
      fieldName: "Wishlist (EN)",
      fieldValue: "field_wishlist_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_wishlist_text_en",
      formType: "input",
      label: "Wishlist (EN)",
      placeholder: "Enter Wishlist (EN)",
      validation: { required: "Wishlist (EN) is required" },
    },
    {
      fieldName: "Wishlist (MS)",
      fieldValue: "field_wishlist_text_malay",
      className: "col-span-6",
      type: "text",
      name: "field_wishlist_text_malay",
      formType: "input",
      label: "Wishlist (MS)",
      placeholder: "Enter Wishlist (MS)",
    },
    {
      fieldName: "Wishlist (ZH)",
      fieldValue: "field_wishlist_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "field_wishlist_text_mandarin",
      formType: "input",
      label: "Wishlist (ZH)",
      placeholder: "Enter Wishlist (ZH)",
    },
  ],

  menuHeader: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],

  categoryBanner: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    // {
    //   fieldName: "Name (MS)",
    //   fieldValue: "field_malay_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_malay_title",
    //   formType: "input",
    //   label: "Name (MS)",
    //   placeholder: "Enter Name (MS)",
    //   // validation: { required: "Name (MS) is required" },
    // },
    // {
    //   fieldName: "Name (ZH)",
    //   fieldValue: "field_mandarin_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_mandarin_title",
    //   formType: "input",
    //   label: "Name (ZH)",
    //   placeholder: "Enter Name (ZH)",
    //   // validation: { required: "Name (ZH) is required" },
    // },
    // {
    //   fieldName: "Categories",
    //   fieldValue: "field_category",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_category",
    //   formType: "select",
    //   label: "Categories",
    //   placeholder: "Enter Categories",
    //   validation: { required: "Categories is required" },
    //   loadOptions: fetchCategoriesBannerData,
    // },
    {
      "fieldName": "Image",
      "fieldValue": "field_common_image",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "field_common_image",
      "formType": "file",
      "label": "Image",
      "placeholder": "Enter Image",
      validation: { required: 'Image is Required' },
      imageDimension: {
        width: 1732,
        height: 110
      }
    },
    {
      fieldName: "Published",
      fieldValue: "publish",
      className: "col-span-12",
      type: "checkbox",
      name: "publish",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],

};
